import React from "react";
import { Select, MenuItem, FormControl } from "@mui/material";

const ActionSelect = ({
  options = [],
  value = "",
  placeholder = "Actions",
  onSelect,
  onChange,
  width = 100,
  size = "small",
}) => {
  const handleChange = (e) => {
    const val = e.target.value;
    onSelect?.(val);
    onChange?.(val);
  };
  const selectedOption = options.find((o) => o.value === value || o.value === Number(value));
  return (
    <FormControl
      size={size}
      sx={{
        backgroundColor: "#F9FAFB",
        borderRadius: "10px",
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "& .MuiSelect-select": {
          padding: "5px 8px",
          fontWeight: 500,
          fontSize: "12px",
          color: "#111827",
        },
        "& .MuiSvgIcon-root": { color: "#6B7280" },
      }}
    >
      <Select
        displayEmpty
        value={value ?? ""}
        renderValue={() => (selectedOption ? selectedOption.label : placeholder)}
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            sx: {
              width,
              borderRadius: "8px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              "& .MuiMenuItem-root": {
                fontSize: "13px",
                padding: "6px 12px",
                "&:hover": { backgroundColor: "#F3F4F6" },
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ActionSelect;
